'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const SuccessIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="SuccessIcon">
      <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.798 5.54163L8.90753 12.3975C8.84598 12.484 8.76803 12.5567 8.67842 12.6111C8.58882 12.6656 8.48942 12.7006 8.38629 12.7141C8.28457 12.7275 8.18127 12.7197 8.08252 12.6912C7.98377 12.6626 7.89157 12.6139 7.81139 12.5479L4.59961 9.89579"
          stroke="#377F86"
          strokeWidth="0.887626"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.383789 9.50004C0.383789 10.6956 0.611799 11.8795 1.0548 12.9841C1.4978 14.0886 2.14712 15.0923 2.96569 15.9377C3.78425 16.7831 4.75602 17.4537 5.82552 17.9112C6.89503 18.3687 8.04131 18.6042 9.19893 18.6042C10.3566 18.6042 11.5028 18.3687 12.5723 17.9112C13.6418 17.4537 14.6136 16.7831 15.4322 15.9377C16.2507 15.0923 16.9001 14.0886 17.3431 12.9841C17.7861 11.8795 18.0141 10.6956 18.0141 9.50004C18.0141 8.30446 17.7861 7.1206 17.3431 6.01603C16.9001 4.91146 16.2507 3.90782 15.4322 3.06242C14.6136 2.21702 13.6418 1.54641 12.5723 1.08889C11.5028 0.63136 10.3566 0.395874 9.19893 0.395874C8.04131 0.395874 6.89503 0.63136 5.82552 1.08889C4.75602 1.54641 3.78425 2.21702 2.96569 3.06242C2.14712 3.90782 1.4978 4.91146 1.0548 6.01603C0.611799 7.1206 0.383789 8.30446 0.383789 9.50004Z"
          stroke="#377F86"
          strokeWidth="0.887626"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  )
}

SuccessIcon.propTypes = {
  sx: PropTypes.object
}
